import { FieldDescriptor } from '../types/modal/FieldDescriptor';
import { EmployeesArray } from '../types/employee/EmployeeGetResponse';
import { EmployeePutRequest } from '../types/employee/EmployeePutRequest';

export const Employee_HEADER = [
  {
    label: '社員コード',
    sortable: true,
    sortKey: 'employee_code',
    width: '200px',
  },
  { label: '氏名', sortable: false, sortKey: '', width: '200px' },
  { label: 'パスワード', sortable: false, sortKey: '', width: '150px' },
  { label: '大連', sortable: false, sortKey: '', width: '100px' },
  { label: '管理者権限', sortable: false, sortKey: '', width: '120px' },
  { label: '操作', sortable: false, sortKey: '', width: '150px' },
];

export const Employee_MODAL_FIELDS: FieldDescriptor<
  EmployeesArray | EmployeePutRequest
>[] = [
  { label: '社員コード', key: 'employeeCode', type: 'text' },
  { label: '氏名', key: 'name', type: 'text' },
  { label: 'パスワード', key: 'password', type: 'text' },
  { label: '大連', key: 'isDairen', type: 'checkbox' },
  { label: '管理者権限', key: 'isAdmin', type: 'checkbox' },
];
